<div class="h-100 d-flex flex-column align-items-center justify-content-center">
    <span class="far fa-meh fa-3x mb-2"></span>
    <h1>{{ "NOT_FOUND.TITLE" | translate }}</h1>
    <h3>{{ "NOT_FOUND.INFO" | translate }}</h3>
    <p-button [title]="'NOT_FOUND.BACK' | translate" color="primary" routerLink="/app" class="mt-3">
        {{ "NOT_FOUND.BACK" | translate }}
    </p-button>
</div>
